import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/analytics';
import './styles/GlobalTypography.css';
import { ArticleProvider } from './context/ArticleContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import TVPage from './pages/TVPage';
import FilmPage from './pages/FilmPage';
import AwardsPage from './pages/AwardsPage';
import FestivalsPage from './pages/FestivalsPage';
import ReviewsPage from './pages/ReviewsPage';
import SearchPage from './pages/SearchPage';
import AdminPanel from './pages/AdminPanel';
import EditArticle from './pages/EditArticle';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import AdminRoute from './components/AdminRoute';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdChoicesPage from './pages/AdChoicesPage';
import NotFoundPage from './pages/NotFoundPage';

// Component to track page views
function Analytics() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(window.location.href, document.title);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <ArticleProvider>
      <Router>
        <Analytics />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/tv" element={<TVPage />} />
          <Route path="/film" element={<FilmPage />} />
          <Route path="/awards" element={<AwardsPage />} />
          <Route path="/festivals" element={<FestivalsPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/iffa-admin-login" element={<AdminLogin />} />
          <Route path="/iffa-admin-2024" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/iffa-admin-2024/create" element={<AdminRoute><AdminPanel /></AdminRoute>} />
          <Route path="/iffa-admin-2024/edit/:id" element={<AdminRoute><EditArticle /></AdminRoute>} />
          <Route path="/edit-article/:id" element={<EditArticle />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/ad-choices" element={<AdChoicesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        <Footer />
      </Router>
    </ArticleProvider>
  );
}

export default App;
